var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-socialEntertainment"},[_c('resolution',{attrs:{"current":_vm.socialEntertainment}}),_c('div',[_c('a',{staticClass:"experience-btn",attrs:{"href":_vm.siteUrl,"target":"_blank"}},[_c('span',[_vm._v("立即体验")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }